import React, { useState, useEffect } from 'react';
import { Menu, X, ArrowUp, Shield, Calculator, Globe, FileCheck, Building, TrendingUp, Users, Award, MapPin, Phone, Mail, Clock } from 'lucide-react';
import HomeSection from '../components/HomeSection';
import TeamSection from '../components/TeamSection';
import ServicesSection from '../components/ServicesSection';
import KnowledgeBankSection from '../components/KnowledgeBankSection';
import QuerySection from '../components/QuerySection';
import CareersSection from '../components/CareersSection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';

const HomePage = () => {
  const [activeTab, setActiveTab] = useState('home');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [showScrollTop, setShowScrollTop] = useState(false);

  const tabs = [
  { id: 'home', label: 'Home' },
  { id: 'team', label: 'Team' },
  { id: 'services', label: 'Services' },
  { id: 'knowledge', label: 'Knowledge Bank' },
  { id: 'query', label: 'Query' },
  { id: 'careers', label: 'Careers' },
  { id: 'contact', label: 'Contact Us' }];


  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 400);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
    setMobileMenuOpen(false);
    // Smooth scroll to section
    const element = document.getElementById(`section-${tabId}`);
    if (element) {
      const offset = 80; // Account for sticky header
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top: elementPosition - offset,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div className="min-h-screen bg-[#FAF8F3]">
      {/* Sticky Navigation */}
      <nav className="sticky top-0 z-50 bg-[#0D1B2A] shadow-lg">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            {/* Logo - Firm name in Bold Gold Eras font */}
            <div className="flex-shrink-0">
              <h1 className="font-eras !text-2xl sm:!text-4xl !italic text-[#C9A84C]">AGDG & Associates</h1>
              <p className="font-dmsans !text-sm sm:!text-base !italic text-gray-300">Chartered Accountants</p>
            </div>

            {/* Desktop Navigation */}
            <div className="hidden lg:flex space-x-1">
              {tabs.map((tab) =>
              <button
                key={tab.id}
                onClick={() => handleTabClick(tab.id)}
                className={`px-4 py-2 text-sm font-dmsans transition-all duration-300 border-b-2 ${
                activeTab === tab.id ?
                'text-[#C9A84C] border-[#C9A84C]' :
                'text-gray-300 border-transparent hover:text-[#C9A84C]'}`
                }>

                  {tab.label}
                </button>
              )}
            </div>

            {/* Mobile Menu Button */}
            <button
  onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
  className="lg:hidden text-[#C9A84C] p-2 rounded-md bg-[#1a2d42] border border-[#C9A84C] border-opacity-40">

  {mobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
</button>
          </div>

          {/* Mobile Navigation */}
          {mobileMenuOpen &&
          <div className="lg:hidden pb-4 space-y-2">
              {tabs.map((tab) =>
            <button
              key={tab.id}
              onClick={() => handleTabClick(tab.id)}
              className={`block w-full text-left px-4 py-2 text-sm font-dmsans transition-colors ${
              activeTab === tab.id ?
              'text-[#C9A84C] bg-[#1a2d42]' :
              'text-gray-300 hover:text-[#C9A84C] hover:bg-[#1a2d42]'}`
              }>

                  {tab.label}
                </button>
            )}
            </div>
          }
        </div>
      </nav>

      {/* Main Content */}
      <main>
        <div id="section-home">
          <HomeSection onNavigate={handleTabClick} />
        </div>
        <div id="section-team">
          <TeamSection />
        </div>
        <div id="section-services">
          <ServicesSection />
        </div>
        <div id="section-knowledge">
          <KnowledgeBankSection />
        </div>
        <div id="section-query">
          <QuerySection />
        </div>
        <div id="section-careers">
          <CareersSection />
        </div>
        <div id="section-contact">
          <ContactSection />
        </div>
      </main>

      {/* Footer */}
      <Footer onNavigate={handleTabClick} />

      {/* Scroll to Top Button */}
      {showScrollTop &&
      <button
        onClick={scrollToTop}
        className="fixed bottom-8 right-8 bg-[#C9A84C] text-[#0D1B2A] p-3 rounded-full shadow-lg hover:bg-[#b8973d] transition-all duration-300 z-40">

          <ArrowUp size={24} />
        </button>
      }
    </div>);

};

export default HomePage;